export const projectsMocks = [
  {
    link: "https://rukadeveloper.github.io",
    figmaLink:
      "https://www.figma.com/design/cVfguDIh64sPJQrmioXTxB/Baseball-Comics?node-id=0-1&t=MZQyutGwEHm7PV3n-1",
    imageUrl: "/images/projects/thumbnail_01.png",
    subject: "Baseball Comics v2",
    second_subject: "베이스볼 코믹스 v2",
    modals: {
      tag: ["사이드", "React", "TS"],
      startPeriod: "2025.06.01",
      endPeriod: "2025.07.01",
      details:
        "Baseball 직관 프로그램을 직접 구현한 React 기반 애플리케이션입니다.|현재 진행중이며, 메인 페이지만 구현된 상태입니다.",
      functions: [
        "로그인 및 회원가입 로그아웃 기능 구현",
        "스크롤 슬라이더 기능 구현",
      ],
      usedLanguage: [
        "React",
        "zustand",
        "typescript",
        "styled-component",
        "Spring Boot",
      ],
      contribution: [
        "Spring Boot을 이용한 CRUD 기능 구현 통한 로그인 / 회원가입 기능",
        "슬라이더 기능 구현 시 Custom Hooks 통해 유지 보수 관리",
      ],
      troubleShooting: [
        "슬라이더에서 overflow-hidden을 사용했으므로, 직접 sticky 효과를 custom-hooks로 해결",
      ],
    },
  },
  {
    link: "https://one-bestfinance.co.kr/DG9557343792/",
    figmaLink:
      "https://www.figma.com/design/ZEnGcCYsTYe97O0iSrsIp5/CPLE?node-id=0-1&t=ZWyYfXAmeyUCMABX-1",
    imageUrl: "/images/projects/thumbnail_02.png",
    subject: "최저금리 안심 서비스",
    second_subject: "최저 금리 안심 서비스",
    modals: {
      tag: ["팀", "Php", "Spring Boot"],
      startPeriod: "2025.06.01",
      endPeriod: "2025.06.20",
      details:
        "대출 서비스를 소개하는 php 기반 애플리케이션입니다.|완료된 프로젝트이며, 실제 폼 데이터가 상담원에게 넘어갑니다",
      functions: [
        "카드 슬라이더 기능 Swiper 라이브러리 이용해 구현",
        "Chart.js를 통해 차트 소개 표현",
      ],
      usedLanguage: ["Php", "Javascript", "Spring-boot", "Chart.js"],
      contribution: [
        "Spring Boot을 이용한 백엔드 처리하기",
        "Swiper.js, Chart.js를 통해 비주얼 이펙트 구현",
      ],
      troubleShooting: [
        "슬라이더 js 반응형 이펙트 resize 이벤트를 이용해서 해결하기",
      ],
    },
  },
  {
    link: "https://kor-bankpartner.co.kr/auto2369360033202411/",
    figmaLink:
      "https://www.figma.com/design/ZEnGcCYsTYe97O0iSrsIp5/CPLE?node-id=472-2&t=etqOWg9fUHKNeJAT-1",
    imageUrl: "/images/projects/thumbnail_03.png",
    subject: "자동차 안심 대출",
    second_subject: "자동차 안심 대출",
    modals: {
      tag: ["팀", "Php", "Spring Boot"],
      startPeriod: "2025.07.01",
      endPeriod: "2025.07.17",
      details:
        "대출 서비스를 소개하는 php 기반 애플리케이션입니다.|완료된 프로젝트이며, 실제 폼 데이터가 상담원에게 넘어갑니다",
      functions: [
        "Spring Boot 이용한 백엔드 처리하기",
        "Form 내부 박스 애니메이션 구현하기",
      ],
      usedLanguage: ["Php", "Javascript", "Spring-boot"],
      contribution: [
        "Spring Boot을 이용한 백엔드 처리하기",
        "애니메이션 기능 사용하기",
      ],
      troubleShooting: ["따로 존재하지 않았음"],
    },
  },
  {
    link: "http://feellog.xyz",
    figmaLink: "https://www.figma.com/design/mjxoXRznOSrmXq37If4Nnc/%EC%8A%A4%EC%9C%84%ED%94%84_%EB%94%94%EC%9E%90%EC%9D%B8?node-id=591-10239&t=Qn8vzyLY8X4lJmTw-1",
    imageUrl: "/images/projects/thumbnail_04.png",
    subject: "감정에 따라 자신의 소비를 피드백",
    second_subject: "Feellog",
    modals: {
      tag: ["팀", "Next.js", "Claude"],
      startPeriod: "2026.03.26",
      endPeriod: "2026.05.06",
      details: "감정에 따라 자신의 소비를 피드백할 수 있는 가계부를 만들었습니다.",
      functions: ["Next.js에서 FSD 구조 따라기", "API 연동 및 FCP 최적화"],
      usedLanguage: ["Next.js",],
      contribution: ["Next.js의 SEO 기능과 FCP 문제 해결"],
      troubleShooting: ["랜더링 최적화 및 JS 번들링 최적화"],
    },
  },
];
